export let cargoCarriers = {
	getPath: () => '/cargoCarriers',
	getByIdPath: (id) => `/cargoCarriers/${id}`,
	getSyncPath: () => '/cargoCarriers/sync',
	getDeletePath: () => '/cargoCarriers/',
};

export let cargoCarrierTypes = {
	getPath: () => 'cargoCarrierTypes',
	getByIdPath: (id) => `/cargoCarrierTypes/${id}`,
	getSyncPath: () => '/cargoCarrierTypes/sync',
};

export let customers = {
	getPath: () => '/customers',
	getAllPath: () => '/customers/all',
	getByNumberPath: (number) => `/customers/customerNumber/${number}`,
	getSyncPath: () => '/customers/sync',
};

export let drivers = {
	getPath: () => '/drivers',
	getByIdPath: (id) => `/drivers/${id}`,
	getSyncPath: () => '/drivers/sync',
	getDeletePath: () => '/drivers/',
};


export let edi = {
	getInboundTransmissionsPath: () => '/edi/inboundTransmissions/getAllByCreateDate',
	getOutboundTransmissionsPath: () => '/edi/outboundTransmissions/getAllByCreateDate',
	inspectOutboundTransmission: (id) => `/edi/outboundTransmissions/inspect/${id}`,
	resendOutboundTransmission: (id) => `/edi/outboundTransmissions/resend/${id}`,
	inspectInboundTransmission: (id) => `/edi/inboundTransmissions/inspect/${id}`,
	reimportInboundTransmission: (id) => `/edi/inboundTransmissions/reimportTransmission/${id}`,
	downloadInboundEdiFile: (transmissionId) => `/edi/inboundTransmissions/downloadFile/${transmissionId}`,
	downloadOutboundEdiFile: (transmissionId) => `/edi/outboundTransmissions/downloadFile/${transmissionId}`,
	edipartsPath: () => '/edi/edipart/getAll',
	metadata: () => '/edi/edipart/metadata',
	patchEdipartPath: (id) => `/edi/edipart/${id}`,
	createNewEdipart: () => '/edi/edipart/createEdipart',
	deleteEdipart: (id) => `/edi/edipart/deleteEdipart/${id}`,
	manualImportPath: (id) => `/edi/testSetups/testInboundSetup/${id}`,
	scheduleEdiSendingTrip: (tripId) => `/edi/trips/scheduleEdiSendingTrip/${tripId}`,
	unscheduleTransporterOrder: (transporterOrderId, subOrderId) => `/edi/transporterOrders/unscheduleOrderForEdi/${transporterOrderId}/${subOrderId}`,
	scheduleSingleOrderOnTransporter: (transporterOrderId, subOrderId) => `/edi/transporterOrders/scheduleOrderForEdi/${transporterOrderId}/${subOrderId}`,
	getEdipartDetails: (edipartId) => `/edi/edipart/edipartDetails/${edipartId}`,
	sendTripOnEdiPath: (id) => `/edi/trips/sendTripOnEdi/${id}`,
	unscheduleOrder: (id, subOrderId) => `/edi/trips/unscheduleOrder/${id}/${subOrderId}`,
	scheduleOrder: (id, subOrderId) => `/edi/trips/scheduleOrder/${id}/${subOrderId}`,
	getEdiLogsPath: (orderId) => `/edi/orders/ediLogs/${orderId}`
};

export let globalAddresses = {
	getPath: () => '/globalAddresses',
	getByIdPath: (id) => `/globalAddresses/${id}`,
	getAllPath: () => '/globalAddresses/all',
	getSyncPath: () => '/globalAddresses/sync',
};

export let goodsTypes = {
	getPath: () => '/goodsTypes',
	getByIdPath: (id) => `/goodsTypes/${id}`,
	getSyncPath: () => '/goodsTypes/sync',
	getDeletePath: () => '/goodsTypes/',
};

export let settings = {
	getAllAvailableSettings:  () => '/settings/allAvailableSettings',
	updateSetting: () => '/settings/update',
};

export let locations = {
	getPath: () => '/locations',
	getByIdPath: (id) => `/locations/${id}`,
	getDefinedPath: () => '/locations/defined',
	getExpandPath: () => `/locations/expand`,
	getExpandPointPath: () => `/locations/expandPoint`,
};

export let maintenance = {
	getDeviationTypesPath: () => '/maintenance/deviations/types',
	getDeviationTypesByIdPath: (id) => `/maintenance/deviations/types/${id}`,
	getDeviationCausesPath: () => '/maintenance/deviations/causes',
	getDeviationCausesByIdPath: (id) => `/maintenance/deviations/causes/${id}`,
};

export let orders = {
	getPath: () => '/orders',
	getByIdPath: (id) => `/orders/${id}`,
	getByQuickSearchPath: (text) => `/orders/quickSearch/${text}`,
	getFilterPath: () => '/orders/filter',
	getSearchPath: () => '/orders/search',
	getMultipleByIdPath: () => '/orders/ids',
	getGeocodeOrdersPath: () => '/orders/geocode',
	openTmsR10Path: (id) => `/orders/openTmsR10/${id}`,
	getTotalsPath: () => '/orders/totals',
};

export let orderTypes = {
	getPath: () => '/orderTypes',
	getByIdPath: (id) => `/orderTypes/${id}`,
	getSyncPath: () => '/orderTypes/sync',
	getDeletePath: () => '/orderTypes/',
};

export let savedLoadPlanningSearches = {
	getPath: () => '/savedLoadPlanningSearches',
	getByIdPath: (id) => `/savedLoadPlanningSearches/${id}`,
	getCountByIdPath: (id) => `/savedLoadPlanningSearches/${id}/count`
};

export let savedOrderSearches = {
	getPath: () => '/savedOrderSearches',
	getByIdPath: (id) => `/savedOrderSearches/${id}`,
	getCountByIdPath: (id) => `/savedOrderSearches/${id}/count`
};

export let savedTripSearches = {
	getPath: () => '/savedTripSearches',
	getByIdPath: (id) => `/savedTripSearches/${id}`,
	getCountByIdPath: (id) => `/savedTripSearches/${id}/count`
};

export let subOrders = {
	getPath: () => '/subOrders',
	getByIdPath: (id) => `/subOrders/${id}`,
	getSendToConfirmPath: (id) => `/subOrders/${id}/send`,
	getByOrderIdPath: (id) => `/subOrders/order/${id}`,
	getSearchPath: () => '/subOrders/search',
	getMultipleByIdPath: () => '/subOrders/ids',
	getMultipleByOrderIdsPath: () => '/subOrders/orderIds',
	getGeocodeOrdersPath: () => '/subOrders/geocode',
	getTotalsPath: () => '/subOrders/totals',
	getCreateParallelPath: (id) => `/subOrders/${id}/parallel`,
};

export let transporters = { getPath: () => '/transporters' };

export let transporterOrders = {
	getPath: () => '/transporterOrders',
	getByIdPath: (id) => `/transporterOrders/${id}`,
};

export let trips = {
	getPath: () => '/trips',
	getByIdPath: (id) => `/trips/${id}`,
	getByIds: () => '/trips/ids',
	getNotifyOrderAddedPath: (id) => `/trips/${id}/notifyOrderAdded`,
	getNotifyOrderRemovedPath: (id) => `/trips/${id}/notifyOrderRemoved`,
	getSearchPath: () => '/trips/search',
	getFilterPath: () => '/trips/filter',
	getSendPath: (id) => `/trips/${id}/send`,
	getDeletePath: () => '/trips/',
	openTmsR10Path: (id) => `/trips/openTmsR10/${id}`,
	getByIdPathOrdersSpecific: (id) => `/trips/orders/${id}`,
	getTripOrdersPath: (id) => `/trips/orders/${id}`,
};

export const legs = {
	getSendPath: (id) => `/legs/${id}/send`,
	getBroadcastPath: (id) => `/legs/${id}/broadcast`,
};

export let tripAddresses = {
	getPath: () => '/tripAddresses',
	getTerminalsPath: () => '/tripAddresses/terminals',
	getByIdPath: (id) => `/tripAddresses/${id}`,
	getAllPath: () => '/tripAddresses/all',
};

export let tripTemplates = {
	getPath: () => '/tripTemplates',
	getNextTripPath: () => '/tripTemplates/calculateNextTrip',
	getGeneratedTripsPath: () => '/tripTemplates/generatedTrips',
	getByIdPath: (id) => `/tripTemplates/${id}`,
	autoSchedulePath: () => '/tripTemplates/autoSchedule'
};

export let unknownItems = {
	getPath: () => '/unknownItems',
	getByIdPath: (id) => `/unknownItems/${id}`,
};

export let vendors = {
	getPath: () => '/vendors',
	getByNumberPath: (number) => `/vendors/vendorNumber/${number}`,
	getByIdPath: (id) => `/vendors/${id}`,
};

export let orderTemplates = {
	getPath: () => '/orderTemplates',
	getByIdPath: (id) => `orderTemplates/${id}`,
	getNextOrderPath: () => 'orderTemplates/calculateNextOrder',
	getGeneratedOrdersPath: () => 'orderTemplates/generatedOrders',
	autoSchedulePath: () => 'orderTemplates/autoSchedule'
};

export let users = {
	getAllPath: () => '/users',
	getCurrentClerk: () => '/users/currentUser'
};

export let incoterms = {
	getPath: () => '/incoterms',
	getByIdPath: (id) => `/incoterms/${id}`,
	getFilteredGlobalPostalPlacesPath: () => '/globalPostalPlace/filter',
	getSyncPath: () => '/incoterms/sync',
	getDeletePath: () => '/incoterms/',
};

export let packageTypes = {
	getPath: () => '/packageTypes',
	getPalletsPath: () => '/packageTypes/pallets',
	getByIdPath: (id) => `/packageTypes/${id}`,
	getFilteredGlobalPostalPlacesPath: () => '/globalPostalPlace/filter',
	getSyncPath: () => '/packageTypes/sync',
	getDeletePath: () => '/packageTypes/',
};

export let references = {
	getPath: () => '/references',
	getByIdPath: (id) => `/references/${id}`,
	getSystemsReferencesPath: () => `/references/system`,
};

export let tripTypes = {
	getPath: () => '/tripTypes',
	getSyncPath: () => '/tripTypes/sync',
};

export let preferredVendors = {
	getPath: () => '/preferredVendors',
	getByIdPath: (id) => `/preferredVendors/${id}`,
};

export let orderChangelogs = {
	getPath: () => '/orderChangelogs',
	getByIdPath: (id) => `/orderChangelogs/${id}`,
};

export let tripChangelogs = {
	getPath: () => '/tripChangelogs',
	getByIdPath: (id) => `/tripChangelogs/${id}`,
};

export let deviations = {
	getPath: () => '/deviations',
	getSearchPath: () => '/deviations/search',
	getByIdPath: (id) => `/deviations/${id}`,
	getActionTypesPath: () => '/deviations/actionTypes',
	getDeviationStatusesPath: () => '/deviations/deviationStatuses',
};
